import React from 'react';

const LABELS = {
  draft: 'Draft',
  pending_finance: 'Pending Finance',
  approved: 'Approved',
  rejected: 'Rejected',
  active: 'Active',
  expired: 'Expired',
  terminated: 'Terminated',
};

const toLabel = (s) => LABELS[s] || (s || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const StatusBadge = ({ status, style, testId }) => (
  <span className={`badge badge-status badge-${status}`} style={style} data-testid={testId || `status-badge-${status}`}>
    <span className="badge-dot" aria-hidden="true" />
    {toLabel(status)}
  </span>
);
